// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__NV+Tc","selectBox":"Welcome_selectBox__rFyY-"};